import React, { memo } from "react";

import { classNames } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { NOTIFICATION_INTRO_SAMPLE } from "../consts";
import { NotificationSceneProps } from "../types";

/** Koliko je primjera stavki označeno dok korisnik ništa nije odabrao. */
const SAMPLE_SELECTED_COUNT = 2;

/** Korak "Odabir stavki": popis stavki s označenima, pa broj odabranih. */
const NotificationEntitiesScene: React.FC<NotificationSceneProps> = ({ notification }) => {
  const selectedCount = notification.entityCount || SAMPLE_SELECTED_COUNT;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Pojedinačno praćenje</div>
          <div className="text-sm font-bold text-slate-800 truncate">{notification.entityLabel}</div>
          <div className="mt-3 space-y-2">
            {NOTIFICATION_INTRO_SAMPLE.entities.map((entity, index) => {
              const isSelected = index < Math.min(selectedCount, NOTIFICATION_INTRO_SAMPLE.entities.length);
              return (
                <div key={entity} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                  <span className={classNames("truncate", isSelected ? "font-semibold text-slate-800" : "text-slate-400")}>{entity}</span>
                  {isSelected ? <CheckIcon /> : <span className="w-5 h-5 rounded-full border-2 border-slate-200" />}
                </div>
              );
            })}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Odabrano</div>
          <div className="mt-2 text-xl font-bold text-slate-800">{selectedCount}</div>
          <div className="mt-1 text-[0.65rem] text-slate-400">stavki prima obavijest</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Samo ono što vas zanima"
          subtitle="Ostale stavke se ne prate"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationEntitiesScene);
